const FacultyITSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35" fill="none">
      <path d="M10.5 11L4.5 17L10.5 23" stroke="#5D6977" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M15.75 26L20.25 8" stroke="#5D6977" strokeWidth="3" strokeLinecap="round" />
      <path d="M25.5 11L31.5 17L25.5 23" stroke="#5D6977" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default FacultyITSvg;
